import React, { useEffect, useState } from 'react';
import './UserTable.css'; 

import { fetchUsers } from '../../../Utils/firebaseServices';

const UserTable = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const getUsers = async () => {
      const fetchedUsers = await fetchUsers();
      setUsers(fetchedUsers);
    };

    getUsers();
  }, []);

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr >
            <th style={{backgroundColor:'black',color:'white'}}>ID</th>
            <th style={{backgroundColor:'black',color:'white'}}>Name</th>
            <th style={{backgroundColor:'black',color:'white'}}>Email</th>
            <th style={{backgroundColor:'black',color:'white'}}>Photo</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="4">No users found</td>
            </tr>
          ) : (
            users.map(user => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.displayName || 'N/A'}</td>
                <td>{user.email || 'N/A'}</td>
                <td>
                  {user.photoURL ? (
                    <img src={user.photoURL} alt="User" className="user-photo" />
                  ) : (
                    'No Photo'
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
